import { AppSidebar } from '@/components/sidebar/app-sidebar'
import Topnav from '@/components/topnav'

import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar'

export default function DashboardLayout({
  children,
}: {
  children: React.ReactNode
}) {
  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset className='bg-[#F9F9F9] h-dvh overflow-y-hidden'>
        {/* <SidebarTrigger /> */}
        <Topnav />
        <section className='p-4 lg:px-8 xl:px-12 h-full overflow-y-auto'>
          {children}
        </section>
      </SidebarInset>
    </SidebarProvider>
  )
}
